module.exports = __webpack_public_path__ + "static/media/14UNEP4.ffb252c4.jpg";